const init = {
  photoMenuHideUsed: false,
};

const reducer = (state = init, action) => {
  switch (action.type) {
    case 'PHOTO_MENU_TOGGLE_HIDE_USED': {
      const previousToggleState = state.photoMenuHideUsed;
      return {
        ...state,
        photoMenuHideUsed: !previousToggleState,
      };
    }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/photobooks/reducers/uiSettings/reducer.js